import graphql from './graphql';

const query = /* GraphQL */ `
  query Course($id: ID) {
    Course(id: $id) {
      id
      name
      description
      trainingHours
      expirationTime
      updatedAt
      thumbnail
      isDraft
      Priority {
        name
        id
      }
      CourseCategory {
        name
        id
      }
      User {
        fullName
        photo
      }
    }
  }
`;

const CourseFindById = async ({ id }) =>
  graphql(query, { id }).then(
    // eslint-disable-next-line camelcase
    ({ Course }) => Course
  );

export default CourseFindById;
